import { createSlice } from "@reduxjs/toolkit";
const userPointsSlice = createSlice({
    name: 'userPoints',
    initialState: {
        pointDetails: null
    },
    reducers: {
        setUserPoints: (state, action) => {
            state.pointDetails = action.payload
        }
    }
});
export const addUserPoints = userPointsSlice.actions.setUserPoints;
export default userPointsSlice.reducer;
